import QuestionnaireAiSuggestion from "../QuestionnaireAiSuggestion";

const getQuestionReason = (question) => {
    if (!question) {
        return "";
    }

    const reason = question.reason ?? question.ai_reason ?? question.aiReason;

    if (typeof reason !== "string") {
        return "";
    }

    return reason.trim();
};

/**
 * Creates a QuestionExtension that shows QuestionnaireAiSuggestion when
 * the question has a reason from the API.
 *
 * @returns {Function}
 */
export const createQuestionnaireAiSuggestionExtension = () => {
    const QuestionnaireAiSuggestionExtension = (props) => {
        const reason = getQuestionReason(props.question);

        if (!reason) {
            return null;
        }

        return (
            <QuestionnaireAiSuggestion reason={reason} />
        );
    };

    QuestionnaireAiSuggestionExtension.displayName =
        "QuestionnaireAiSuggestionExtension";

    return QuestionnaireAiSuggestionExtension;
};

export default createQuestionnaireAiSuggestionExtension;
